import { DndContext, DragEndEvent } from "@dnd-kit/core";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useGamesAPI, useGamesData } from "../../context/GamesProvider";
import { useDndGameReducer } from "./DndGameReducer";

export const DndGameModule = () => {
  console.log("dndGameModule render");

  //  CONTEXT
  const { validateGame, setProgress } = useGamesAPI();
  const { current } = useGamesData();

  //  LOGIC
  const { dispatch, draggables, droppables, data } = useDndGameReducer({
    current,
  });

  //  EVENTS
  useEffect(() => {
    if (data.isValid) validateGame();
  }, [data.isValid, validateGame]);

  useEffect(() => {
    setProgress(data.progress ?? 0);
  }, [data.progress, setProgress]);

  //  HANDLES
  const handleDragEnd = (event: DragEndEvent) => {
    console.log(`drop ${event.active.id} over ${event.over?.id ?? "nothing"}`);
    if (
      event.over &&
      event.active.data.current &&
      event.active.data.current?.hostedBy !== event.over.id &&
      event.active.data.current?.hostedBy !== ""
    )
      dispatch({
        type: "switch",
        drag: event.active.id,
        from: event.active.data.current.hostedBy,
        to: event.over.id,
        other: "",
      });
    else if (event.over)
      dispatch({ type: "dropTo", drag: event.active.id, to: event.over.id });
    else dispatch({ type: "reset", id: event.active.id });

    dispatch({ type: "validate" });
  };

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <Grid
        item
        container
        justifyContent="center"
        mb={5}
        // spacing={4}
        mt={5}
      >
        <Grid
          item
          container
          justifyContent="center"
          xs={11}
          py={2}
          mb={2}
          bgcolor={"grey.50"}
          borderRadius={5}
          minHeight={"8em"}
        >
          {draggables}
        </Grid>
        <Grid
          item
          container
          xs={11}
          spacing={4}
          justifyContent="space-around"
          mb="5em"
        >
          {droppables}
        </Grid>
      </Grid>
    </DndContext>
  );
};
